






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencyModule } from '@/store/modules/agency';
import JobDto from '@/models/Jobs/JobDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import UpdateJobLocationDetailsRequest from '@/models/Jobs/UpdateJobLocationDetailsRequest';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import { LocationListModule } from '@/store/modules/locationList';

@Component({
    name: 'JobLocationDetailsEdit'
})
export default class JobLocationDetailsEdit extends GiganautVueDialog {
 
  entity: JobDto = new JobDto();
  contactLocations: ContactLocationDto[] = [];
  selectedContactLocation: ContactLocationDto = new ContactLocationDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(JobDetailsModule.currentJob));
      const contactLocation = new ContactLocationDto();
      contactLocation.contact = this.entity.contact
      this.selectedContact = contactLocation;
      if (LocationListModule.locations.length === 0) {
        await LocationListModule.searchLocations();
      }
    }
  }

  @Watch("entity.location")
  async onLocationChanged(newVal: LocationProfileDto, oldVal: LocationProfileDto) {
    if (newVal.id) { 
      //We get this direct as introducing the store would be pointless - it's throw away data
      await ajax.get(`/api/v1/agency/locations/${newVal.id}/contacts`)
      .then(response => {
        this.contactLocations = response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);

      })
    }
  }

  get selectedContact() {
    return this.selectedContactLocation;
  }

  set selectedContact(contactLocation: ContactLocationDto) {
    this.selectedContactLocation = contactLocation;
    this.entity.contact = contactLocation.contact;
    this.entity.contactId = contactLocation.contactId;
  }

  get locations() {
    return LocationListModule.locations;
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateJobLocationDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.locationId = this.entity.location.id;
    request.contactId = this.entity.contact.id;
    await JobDetailsModule.editJobLocationDetails(request)
    this.dialog = false;
  }
}
